import { Box, Card, Chip, Divider, Grid, TextField, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import FirebaseService from "../../../services/firebase/FirebaseService";
import ReadleeProfile from "../../../services/firebase/ReadleeProfile";
import Submission from "../../../interfaces/Submission";
import RecordedPage from "../../../interfaces/RecordedPage";
import Page from "../../../interfaces/Page";
import Transcript from "../../../interfaces/Transcript";
import { Autocomplete } from "@material-ui/lab";
import Shiitake from "shiitake";
import StudentHeader from "../../StudentHeader/StudentHeader";
import { RootState } from "../../../state/configureStore";
import { connect } from "react-redux";
import Loading from "../../Loading/Loading";
import { Redirect, Route } from "react-router-dom";
import UploadService from "../../../services/upload/UploadService";
import ReactPlayer from "react-player";
import Classroom from "../../../interfaces/Classroom";
import { getAge } from "../../../interfaces/Birthday";

// This file is a mess.  This was put together as some quick testing.
// If it's going to live on, it needs to be cleaned up.

type StudentPerformanceScreenProps = ReturnType<typeof mapStateToProps>;

function StudentPerformanceScreen(props: StudentPerformanceScreenProps) {
  const [users, setUsers] = useState<ReadleeProfile[]>([]);
  const [classrooms, setClassrooms] = useState<Classroom[]>([]);
  const [classroom, setClassroom] = useState<Classroom | null>(null);
  const [teacher, setTeacher] = useState<ReadleeProfile | null>(null);
  const [student, setStudent] = useState<ReadleeProfile | null>(null);
  const [studentId, setStudentId] = useState("");
  const [bookId, setBookId] = useState("");
  const [submissions, setSubmissions] = useState<Submission[]>([]);
  const [recordedPages, setRecordedPages] = useState<RecordedPage[]>([]);
  const [recordedPage, setRecordedPage] = useState<RecordedPage | null>(null);
  const [libraryPage, setLibraryPage] = useState<Page | null>(null);
  const [uploadPaths, setuploadPaths] = useState<string[]>([]);
  const isConnecting = props.isConnectingUser && props.isConnectingSettings;
  useEffect(() => {
    if (!isConnecting && props.profile && props.profile.isAdmin) {
      FirebaseService.getUsers().then(setUsers);
      FirebaseService.getClasses().then(classrooms => {
        const classroomsWithStudents = classrooms.filter(classroom => {
          return classroom.students && Object.values(classroom.students).length > 0;
        });

        setClassrooms(classroomsWithStudents);
      });
    }
  }, [isConnecting, props.profile]);

  if (isConnecting) {
    return <Loading />;
  }

  // Ensure the user is logged in
  if (!props.profile) {
    return <Route component={() => <Redirect to={{ pathname: "/Login" }} />} render={undefined} />;
  }

  // Ensure the user has access
  if (!props.profile.isAdmin) {
    return <Route component={() => <Redirect to={{ pathname: "/Home" }} />} render={undefined} />;
  }

  if (users.length === 0) {
    return <Loading />;
  }

  const teacherSelected = async (_event: unknown, newTeacher: ReadleeProfile | null) => {
    if (newTeacher) {
      setTeacher(newTeacher);
    } else {
      setTeacher(null);
      setClassroom(null);
      setStudentId("");
    }
  };

  const classroomSelected = async (_event: unknown, newClassroom: Classroom | null) => {
    if (newClassroom) {
      setClassroom(newClassroom);
    } else {
      setClassroom(null);
      setStudentId("");
    }
  };

  const userSelected = async (_event: unknown, user: ReadleeProfile | null) => {
    if (user) {
      setStudentId(user.uid);
      setStudent(user);
      setSubmissions(await FirebaseService.getSubmissions(user.uid));
    } else {
      setStudentId("");
      setStudent(null);
    }
  };

  const submissionSelected = async (_event: unknown, newSubmission: Submission | null) => {
    if (newSubmission?.book?.id) {
      setBookId(newSubmission.book.id);
      setRecordedPages(await FirebaseService.getRecordedPages(studentId, newSubmission.book.id));
    } else {
      setBookId("");
      setRecordedPages([]);
    }

    setRecordedPage(null);
  };

  const pageSelected = async (_event: unknown, recordedPage: RecordedPage | null) => {
    if (recordedPage) {
      const page = await FirebaseService.getPage(bookId, recordedPage.pageId);

      const newUploadPaths = [];

      if (recordedPage && recordedPage.transcripts) {
        for (let i = 0; i < recordedPage.section || 0; i++) {
          const uploadPath = await UploadService.getPageAudio(recordedPage?.storageFolderPath || "", `s${i}`);
          newUploadPaths.push(uploadPath);
        }
      }

      setuploadPaths(newUploadPaths);
      setLibraryPage(page);
      setRecordedPage(recordedPage);
    } else {
      setLibraryPage(null);
      setRecordedPage(null);
    }
  };

  const renderTranscript = () => {
    const transcripts: Transcript[] = [];

    if (recordedPage && recordedPage.transcripts) {
      for (let i = 0; i < recordedPage.section || 0; i++) {
        const transcript = recordedPage.transcripts[`s${i}`];
        if (transcript) {
          transcripts.push(transcript);
        }
      }
    }

    return (
      <div>
        {transcripts.map((transcript, index) => {
          return (
            <div key={`transcriptdiv${index}`}>
              <ReactPlayer controls width="100%" height={40} url={uploadPaths[index]} />
              {transcript?.transcript || ""}
              <hr />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "#efe7dd", height: "100vh", margin: 0, display: "flex", flexFlow: "column" }}>
      <StudentHeader />
      <div style={{ padding: "20px" }}>
        {
          //////////////////////////////////////////////
          //                 Filters                  //
          //////////////////////////////////////////////
        }

        <Grid container spacing={4}>
          {/* Teacher Filter */}

          <Grid item xs={2}>
            <Autocomplete
              renderInput={params => {
                return <TextField {...params} label="Teacher" variant="outlined" />;
              }}
              onChange={teacherSelected}
              renderOption={user => {
                return (
                  <Box width="100%">
                    <Typography component="div" variant="subtitle1">
                      {user.displayName || `${user.firstName} ${user.lastName}`}
                    </Typography>
                    <Divider variant="fullWidth" style={{ marginTop: 0, marginBottom: 5 }} />
                    <Typography component="div" variant="body1">
                      {user.email}
                    </Typography>
                  </Box>
                );
              }}
              getOptionLabel={user => (user.displayName || `${user.firstName} ${user.lastName}`) + ` ${user.email}`}
              options={users
                .filter(user => user.userType === "teacher")
                .filter(obj => classrooms.find(classroom => classroom.teacher?.uid === obj?.uid))
                .sort((obj1, obj2) => {
                  const name1 = obj1.displayName || `${obj1.firstName} ${obj1.lastName}`;
                  const name2 = obj2.displayName || `${obj2.firstName} ${obj2.lastName}`;
                  return name1 < name2 ? -1 : 1;
                })}
            />
          </Grid>

          {/* Classroom Filter */}

          <Grid item xs={2}>
            <Autocomplete
              renderInput={params => {
                return <TextField {...params} label="Classroom" variant="outlined" />;
              }}
              onChange={classroomSelected}
              renderOption={classroom => {
                return (
                  <Box width="100%">
                    <Typography component="div" variant="subtitle1">
                      <Shiitake lines={1}>{classroom.className || classroom.id}</Shiitake>
                    </Typography>
                  </Box>
                );
              }}
              getOptionLabel={classroom => classroom.className || classroom.id || ""}
              options={classrooms
                .filter(obj => !teacher || obj.teacher?.uid === teacher.uid)
                .sort((obj1, obj2) => ((obj1?.className || "") > (obj2?.className || "") ? 1 : -1))}
            />
          </Grid>

          {/* Student Filter */}

          <Grid item xs={3}>
            <Autocomplete
              renderInput={params => {
                return <TextField {...params} label="Student" variant="outlined" />;
              }}
              onChange={userSelected}
              renderOption={user => {
                return (
                  <Box width="100%">
                    <Typography component="div" variant="subtitle1">
                      {user.email}
                    </Typography>
                    <Divider variant="fullWidth" style={{ marginTop: 0, marginBottom: 5 }} />
                    <Chip
                      style={{ marginRight: 5 }}
                      label={`${((user?.accuracy || 0) * 100).toFixed(0)}% Accuracy`}
                      size="small"
                    />
                    <Chip
                      style={{ marginRight: 5 }}
                      label={`${((user?.completionPercentage || 0) * 100).toFixed(0)}% Completion`}
                      size="small"
                    />
                    <Chip
                      style={{ marginRight: 5 }}
                      label={`${user?.totalReadings} ${user?.totalReadings > 1 ? "Readings" : "Reading"}`}
                      size="small"
                    />
                  </Box>
                );
              }}
              getOptionLabel={option => option.email}
              options={users
                .filter(user => user.userType === "student")
                .filter(user => user.totalTimeRead > 0)
                .filter(
                  user =>
                    !classroom ||
                    (classroom.students && classroom.students.hasOwnProperty(user.uid) && classroom.students[user.uid]),
                )
                .sort((obj1, obj2) => (obj1.accuracy < obj2.accuracy ? 1 : -1))}
            />
          </Grid>

          {/* Submission Filter */}

          <Grid item xs={3}>
            <Autocomplete
              renderInput={params => {
                return <TextField {...params} label="Submission" variant="outlined" />;
              }}
              onChange={submissionSelected}
              renderOption={submission => {
                return (
                  <Box width="100%">
                    <Typography component="div" variant="subtitle1">
                      {submission.book?.name}
                    </Typography>
                    <Divider variant="fullWidth" style={{ marginTop: 0, marginBottom: 5 }} />
                    <Chip style={{ marginRight: 5 }} label={`${submission.totalTime} Seconds`} size="small" />
                    <Chip
                      style={{ marginRight: 5 }}
                      label={`${((submission.accuracy || 0) * 100).toFixed(0)}% Accuracy`}
                      size="small"
                    />
                    <Chip
                      style={{ marginRight: 5 }}
                      label={`${((submission?.completionPercentage || 0) * 100).toFixed(0)}% Completion`}
                      size="small"
                    />
                  </Box>
                );
              }}
              getOptionLabel={option => option.book?.name || ""}
              options={submissions.sort((obj1, obj2) => (obj1.book?.name || "").localeCompare(obj2.book?.name || ""))}
            />
          </Grid>

          {/* Page Filter */}

          <Grid item xs={2}>
            <Autocomplete
              renderInput={params => {
                return <TextField {...params} label="Page" variant="outlined" />;
              }}
              onChange={pageSelected}
              renderOption={page => {
                return (
                  <Box width="100%">
                    <Typography component="div" variant="subtitle1">
                      <Shiitake lines={1}>
                        {page.transcripts && page.transcripts["s0"] && page.transcripts["s0"].transcript}
                      </Shiitake>
                    </Typography>
                    <Divider variant="fullWidth" style={{ marginTop: 0, marginBottom: 5 }} />
                    <Chip label={`${page.totalTime} Seconds`} size="small" />
                  </Box>
                );
              }}
              // value={recordedPage || (recordedPages && recordedPages.length > 0 ? recordedPages[0] : undefined)}
              inputValue={recordedPage?.transcripts ? recordedPage.transcripts["s0"]?.transcript || "" : ""}
              getOptionLabel={page => page?.transcripts["s0"]?.transcript || ""}
              options={recordedPages}
            />
          </Grid>
        </Grid>
      </div>

      {
        //////////////////////////////////////////////
        //                  Cards                   //
        //////////////////////////////////////////////
      }

      <div style={{ margin: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Card style={{ padding: 10, textAlign: "center" }}>
              Accuracy
              <Divider style={{ marginTop: 2, marginBottom: 5 }} />
              {((recordedPage?.accuracy || 0) * 100).toFixed(0)}%
            </Card>
          </Grid>
          <Grid item xs={2}>
            <Card style={{ padding: 10, textAlign: "center" }}>
              Completion
              <Divider style={{ marginTop: 2, marginBottom: 5 }} />
              {((recordedPage?.completionPercentage || 0) * 100).toFixed(0)}%
            </Card>
          </Grid>
          <Grid item xs={2}>
            <Card style={{ padding: 10, textAlign: "center" }}>
              Date
              <Divider style={{ marginTop: 2, marginBottom: 5 }} />
              {recordedPage?.timeSubmitted ? new Date(recordedPage.timeSubmitted).toLocaleString() : "Unknown"}
            </Card>
          </Grid>
          <Grid item xs={2}>
            <Card style={{ padding: 10, textAlign: "center" }}>
              Age
              <Divider style={{ marginTop: 2, marginBottom: 5 }} />
              {student?.birthday ? getAge(student.birthday) : "Unknown"}
            </Card>
          </Grid>
          <Grid item xs={2}>
            <Card style={{ padding: 10, textAlign: "center" }}>
              WPM
              <Divider style={{ marginTop: 2, marginBottom: 5 }} />
              {recordedPage?.wordsPerMin?.toFixed(0) || "Unknown"}
            </Card>
          </Grid>
        </Grid>
      </div>

      {
        //////////////////////////////////////////////
        //                 Content                  //
        //////////////////////////////////////////////
      }

      <div
        style={{
          margin: "20px",
          display: "flex",
          flexFlow: "column",
          flexGrow: 1,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {recordedPage && libraryPage && (
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography variant="h5" style={{ padding: 5 }}>
                Library Text
              </Typography>
              <Card style={{ padding: 10 }}>
                <span>{libraryPage.title}</span>
                <div dangerouslySetInnerHTML={{ __html: libraryPage.content.replace("\n", "<br /><br />") || "" }} />
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h5" style={{ padding: 5 }}>
                Processed Text
              </Typography>
              <Card style={{ padding: 10 }}>
                <div dangerouslySetInnerHTML={{ __html: recordedPage.correctedString || "" }} />
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="h5" style={{ padding: 5 }}>
                Raw Transcription Segments
              </Typography>
              <Card style={{ padding: 10 }}>{renderTranscript()}</Card>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  profile: state.currentUserState.currentUser,
  isConnectingUser: state.currentUserState.isConnectingUser,
  isLoggedIn: state.currentUserState.currentUser !== undefined,
  isConnectingSettings: state.currentUserState.isConnectingSettings,
  userSettings: state.currentUserState.currentUserSettings,
});

export default connect(mapStateToProps)(StudentPerformanceScreen);
